<template lang='pug'>
  div
    slot(:product="product")
</template>

<script>
  import vueProductSvc from '../services/vueProductSvc';

  export default {
    props: {
      productId: {
        type: [String, Number]
      },

      productCode: {
        type: String
      },

      productUrlKey: {
        type: String
      }
    },

    asyncComputed: {
      product() {
        if (this.productId) {
          return vueProductSvc.getProductById({id: this.productId}).then(res => res.data);
        } else if (this.productCode) {
          return vueProductSvc.getProductByCode({code: this.productCode});
        } else {
          return vueProductSvc.getProductByUrlKey({urlKey: this.productUrlKey});
        }
      }
    }
  }
</script>
